module.exports = __webpack_public_path__ + "static/media/more_active.d6625c22.svg";